import { FaTelegram, FaWhatsapp, FaLine, FaSignalMessenger } from "react-icons/fa6";
import type { IconType } from "react-icons";
import type { SupportedSidecarChannel } from "@whatslly/commons/sidecarUtils";

export type RemoteSyncChannelConfig = {
  channelKey: SupportedSidecarChannel;
  displayName: string;
  icon: IconType;
  route: string;
};

export const remoteSyncChannelsConfig: RemoteSyncChannelConfig[] = [
  {
    channelKey: "whatsapp",
    displayName: "WhatsApp",
    icon: FaWhatsapp,
    route: "/channels/mobile/whatsapp",
  },
  {
    channelKey: "telegram",
    displayName: "Telegram",
    icon: FaTelegram,
    route: "/channels/mobile/telegram",
  },
  {
    channelKey: "line",
    displayName: "Line",
    icon: FaLine,
    route: "/channels/mobile/line",
  },
  {
    channelKey: "signal",
    displayName: "Signal",
    icon: FaSignalMessenger,
    route: "/channels/mobile/signal",
  },
];
